"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ahooks_1 = require("ahooks");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var coupon_items_1 = require("../coupon-items");
function CouponOMOne(props) {
    var style = props.style, className = props.className, title = props.title, icon = props.icon, list = props.list, tabs = props.tabs, price = props.price, subPrice = props.subPrice, buttonText = props.buttonText, tagTxt = props.tagTxt, describe = props.describe, link = props.link, theme = props.theme, onClick = props.onClick;
    var _a = (0, useConfig_1.default)(), classPrefix = _a.classPrefix, mobileWidth = _a.mobileWidth;
    var themeClass = "om-one-theme-".concat(theme || 'blue');
    var size = (0, ahooks_1.useSize)(document.querySelector('body'));
    /**
     * 若是tabs和list同时存在，优先渲染tabs
     */
    function renderTabList() {
        if (tabs) {
            return react_1.default.createElement(coupon_items_1.Select, { theme: theme, tabs: tabs });
        }
        if (list) {
            return react_1.default.createElement(coupon_items_1.CheckList, { theme: theme, list: list });
        }
        return null;
    }
    function renderDescribeLink() {
        return (react_1.default.createElement("p", { className: "om-describe" },
            describe,
            link && react_1.default.createElement(coupon_items_1.Link, __assign({}, link))));
    }
    function renderMobile() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "om-left" },
                react_1.default.createElement(coupon_items_1.IconTitle, { title: title, icon: icon }),
                react_1.default.createElement("div", { className: "om-title" }, price),
                react_1.default.createElement("div", { className: "om-subprice" }, subPrice),
                renderDescribeLink(),
                renderTabList(),
                react_1.default.createElement(coupon_items_1.Tag, { tagTxt: tagTxt })),
            react_1.default.createElement(coupon_items_1.Snap, { theme: theme, isMobile: true }),
            react_1.default.createElement("div", { className: "om-right" },
                react_1.default.createElement("button", { onClick: onClick, className: "om-button" }, buttonText))));
    }
    function renderPC() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "om-left" },
                react_1.default.createElement(coupon_items_1.IconTitle, { title: title, icon: icon }),
                renderDescribeLink(),
                renderTabList()),
            react_1.default.createElement(coupon_items_1.Snap, { theme: theme }),
            react_1.default.createElement("div", { className: "om-right" },
                react_1.default.createElement("div", { className: "om-right-inner" },
                    react_1.default.createElement("div", { className: "om-title" }, price),
                    react_1.default.createElement("div", { className: "om-subprice" }, subPrice),
                    react_1.default.createElement("button", { onClick: onClick, className: "om-button" }, buttonText)),
                react_1.default.createElement(coupon_items_1.Tag, { tagTxt: tagTxt }))));
    }
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)("".concat(classPrefix, "-coupon-om-one"), themeClass, {
            'coupon-om-mobile': Number(size === null || size === void 0 ? void 0 : size.width) <= mobileWidth,
        }, className) }, Number(size === null || size === void 0 ? void 0 : size.width) <= mobileWidth ? renderMobile() : renderPC()));
}
exports.default = CouponOMOne;
//# sourceMappingURL=CouponOMOne.js.map